module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 019-9e6c1665254930e3f2eb34aa2912d554.png";